import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StartPageComponent } from './components/start-page/start-page.component';
import { EinvoiceViewerComponent } from 'projects/einvoice-viewer/src/lib/components/einvoice-viewer/einvoice-viewer.component';
import { EInvoiceViewerConfiguration } from 'projects/einvoice-viewer/src/lib/interfaces/einvoice-viewer-configuration.interface';
//import { EinvoiceViewerComponent, EInvoiceViewerConfiguration } from 'einvoice-viewer';

const routes: Routes = [
  {
    path: '',
    component: EinvoiceViewerComponent,
    data: {
      configuration: {
        dragAndDropEnabled: true,
        buttonBar: {
          zoomControls: true,
          uploadFile: true,
          technicalDetails: true,
          print: true,
        },
        defaultZoomLevel: 0,
        views: {
          pdf: true,
          modelTree: true,
          xml: true,
        },
      } as EInvoiceViewerConfiguration,
    }
  },
  {
    path: 'start',
    component: StartPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
